export const selectOffers = state => state.offers.offers;
